import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="profile-job-category"
export default class extends Controller {
  static targets = ["conditional", "input"];

  connect() {
    if (!this.hasInputTarget) return;
    this.inputTarget.addEventListener("change", this.toggle.bind(this));
    this.toggle();
  }

  disconnect() {
    if (!this.hasInputTarget) return;
    this.inputTarget.removeEventListener("change", this.toggle.bind(this));
  }

  toggle() {
    if (!this.hasInputTarget) return;

    this.hasConditionalTarget && this.conditionalTargets.forEach((target) => {
      const shouldShow = this.inputTarget.value === target.dataset.jobCategoryId;
      if (shouldShow) {
        target.classList.remove("d-none");
      } else {
        target.classList.add("d-none");

        const childArray = Array.from(target.children);
        childArray.forEach((child) => {
          if (child.classList.contains("conditional-input")) {
            child.value = "";
          }
        });
      }
    });
  }
}
